import { Link } from 'react-router-dom';
import { getArticlesByCategory } from '@/mocks/gossip';

export default function GroupHighlightSection() {
  const items = getArticlesByCategory('group');

  return (
    <section className="bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-accent-400">
              <span className="h-3 w-1 rounded-full bg-accent-400" aria-hidden="true" />
              高光同框
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              两个人之间那道刚好的缝隙
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-200/80 md:text-base">
              同框照片好不好看，和颜值关系没那么大。间距、重心与视线方向，才决定了画面里的那股默契。
            </p>
          </div>
          <Link
            to="/category/group"
            className="flex h-10 w-fit cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-accent-400/60 px-4 text-sm font-medium text-accent-300 transition-colors hover:bg-accent-500 hover:text-foreground-950"
          >
            进入同框专栏
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {items.map((article, index) => (
            <article key={article.id} className="group flex flex-col">
              <Link
                to={`/article/${article.slug}`}
                className="relative block h-56 w-full overflow-hidden rounded-lg"
              >
                <img
                  src={article.image}
                  alt={article.alt}
                  title={`${article.title} - 诱惑吃瓜`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-4 top-4 flex h-9 w-9 items-center justify-center rounded-full font-heading text-sm font-bold ${
                    index === 0
                      ? 'bg-accent-500 text-foreground-950'
                      : 'bg-background-50/95 text-primary-700'
                  }`}
                >
                  0{index + 1}
                </span>
              </Link>
              <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-background-50 transition-colors group-hover:text-accent-300">
                <Link to={`/article/${article.slug}`}>{article.title}</Link>
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200/75">
                {article.excerpt}
              </p>
              <span className="mt-3 flex items-center gap-2 text-xs text-background-200/60">
                <i className="ri-time-line text-sm" aria-hidden="true"></i>
                {article.readTime} · {article.views} 阅读
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}